import "./Login.css";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";

const LoginComponent = ({setAuthToken, telegramId }) => {
  const navigate = useNavigate();
  const [otpCode, setOtpCode] = useState("");

  const telegram_id = telegramId;

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://newapi.click/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ telegram_id, otpCode }),
      });

      const data = await response.json();

      if (response.ok) {
        setAuthToken(data.token); // Store the token
      } else {
        //setError(data.message || "Login failed");
      }
    } catch (err) {
      //setError("Network error: Could not connect to the server.");
    }
  };

  return (
    <div className="mainContainer">
      <div className="wrapper">
        <div className="otpLoginContainer">
          <span className="title">PARSER</span>
          <div className="otpContainer">
            <div className="otpMain">
              <span>Enter OTP</span>
              <input
                placeholder="Enter Code OTP"
                type="text"
                value={otpCode}
                maxLength={6}
                onChange={(e) => setOtpCode(e.target.value)}
                onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              />
              <button onClick={(e) => handleLogin(e)}>Login</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginComponent;
